import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DataPolicy from 'src/components/DataPolicy/DataPolicy';
import Checkbox from 'src/components/form-components/Checkbox/Checkbox';
import ValidationMessage from 'src/components/form-components/ValidationMessage/ValidationMessage';
import Popup from 'src/components/Popup/Popup';
import { AppContext } from 'src/contexts/AppContext';
import { BookingContext } from 'src/contexts/BookingFlowContext';
import globalMessages from 'src/services/globalMessages';
import { reservationEndFields } from 'src/services/validations/reservationEndRules';
import { IPrivacyStatementProps } from '../../sections/StatementSection/StatementSection';

const PrivacyStatement: React.FC<IPrivacyStatementProps> = ({ validation, setDataPolicy }) => {

    const { user } = useContext(AppContext);
    const { reservationEndUser } = useContext(BookingContext);
    const [isDataPolicyVisible, setDataPolicyVisible] = useState(false);

    const handleCheckBoxLinkClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.preventDefault(); 
        e.stopPropagation();
        setDataPolicyVisible(true);
    }

    return (
        (!user || !user.PrivacyStatementAccepted)
            ?
            <div className='reservation-end__statement'>
                <Checkbox
                    checked={reservationEndUser.PrivacyStatementAccepted ?? false}
                    onChange={setDataPolicy}
                    required={true} >
                    <FormattedMessage
                        {...globalMessages.privacyAccept}
                        values={{
                            span: (msg: React.ReactNode) => (
                                <span
                                    className="link"
                                    onClick={handleCheckBoxLinkClick}
                                >{msg}</span>)}}
                    />
                </Checkbox>
                <ValidationMessage message={validation.fields[reservationEndFields.PrivacyStatementAccepted]?.message} />
                <Popup
                    visible={isDataPolicyVisible}
                    closePopup={() => setDataPolicyVisible(false)}
                    title={globalMessages.dataPolicyTitle}>
                    <DataPolicy closePopup={() => setDataPolicyVisible(false)} />
                </Popup>
            </div>
            :
            null
    );
}

export default PrivacyStatement;